import { Box, styled, Typography } from '@mui/material'
import { CheckMarkCircleSmall, TrashIcon } from 'components'
import dayjs from 'dayjs'
import ErrorIcon from '@mui/icons-material/Error'
import CancelIcon from '@mui/icons-material/Cancel'
import { TConsistency } from '../../../../../types/models/Consistency'

interface Props {
  active?: boolean
  date?: string
  onClick(): void
  consistency: TConsistency
  isDiscarded: boolean
}

const Container = styled(Box)`
  width: 90px;
  height: 130px;
  display: flex;
  /* display: flex; */
  flex-direction: column;
  background-color: #f9f9f9;
  border: 1px solid #e1e1e1;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  flex-shrink: 0;
  transition: 0.4s;
`

const TopContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active: boolean }>(({ active, theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  flex: 1,
  backgroundColor: active
    ? theme.palette.primary.main
    : theme.palette.grey[300],
  color: active ? theme.palette.common.white : theme.palette.text.primary,
}))

const IconContainer = styled(Box)<{ color?: string }>`
  display: flex;
  height: 48px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  color: ${({ color }) => color || 'inherit'};
`

function DetailListItem({
  active,
  date,
  consistency,
  isDiscarded,
  onClick,
}: Props) {
  const Icon =
    consistency?.name.toLocaleLowerCase() === 'inconsistent' ? (
      <CancelIcon />
    ) : consistency?.color?.name === 'Red' ? (
      <ErrorIcon fontSize="medium" />
    ) : (
      <CheckMarkCircleSmall />
    )

  return (
    <Container onClick={onClick}>
      <TopContainer active={active}>
        <Typography fontWeight="900" fontSize="18px">
          {dayjs(date).format('DD.MM.YY')}
        </Typography>
        <Typography fontSize="14px">{dayjs(date).format('HH:mm')}</Typography>
      </TopContainer>
      <IconContainer color={consistency?.color?.hex_code}>
        {isDiscarded ? <TrashIcon /> : Icon}
      </IconContainer>
    </Container>
  )
}

export default DetailListItem
